module.exports = __webpack_public_path__ + "@/assets/img/creditos-teclab.843d3dac.svg";